import $ from 'jquery';
import ImageDelayLoadClass from '../../libs/load/ImageDelayLoadClass';
import ImageSlideClass from '../../libs/ui/ImageSlideClass';
import Util from '../../libs/util/Util';

/**
 * ギャラリー単体 管理
 */
export default class ImageGallerySlideClass extends ImageSlideClass {
  constructor(_parent, _isImages) {
    super(_parent);
    this.name = 'ImageGallerySlideClass';
    this.isAutoStart = false;
    this.isImages = _isImages;
  }

  onResize(_size) {
    let width = this.$wrap.width();
    this.$items.css({ width: width });
    super.onResize(_size);
  }

  addDelayLoad() {
    const self = this;
    this.delayItems = [];

    if (this.isImages) {
      this.$items.each((index, element) => {
        self.delayItems.push(new ImageDelayLoadClass($(element), true, true));
      });
    } else {
      $('a', this.$items).each((index, element) => {
        self.delayItems.push(new ImageDelayLoadClass($(element), true, true));
      });
    }

    for (let k in this.delayItems) {
      this.delayItems[k].onCreate();
      this.delayItems[k].isImageLoadEnd = true;
      this.delayItems[k].onResize(Util.getWindowSize());
    }
  }

  jump(_href) {
    let index = this.$items.index(this.$items.filter('[data-src="' + _href + '"]').eq(0));
    if (index < 0) { index = 0; }
    this.justMove(index);
  }
}
